import { nextCargoApi } from "../../baseApi";
import { SaveCheckoutLog } from "./checkout.types";

export const checkoutApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    saveCheckoutLog: build.mutation<SaveCheckoutLog["result"], SaveCheckoutLog["args"]>({
      query: (body) => ({
        url: "/checkout/log",
        method: "POST",
        body
      }),
      extraOptions: {
        maxRetries: 2
      }
    })
  })
});

checkoutApi.enhanceEndpoints({
  endpoints: {}
});
